/* Shopify-Store: global behaviour (small, dependency-free). */
(function () {
  // Auto-submit sort select on collection pages.
  document.querySelectorAll('[data-ss-autosubmit] select').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  // Cart quantity inputs: submit the cart form on change.
  document.querySelectorAll('[data-ss-autosubmit-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.form;
      if (!form) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
      form.appendChild(hidden);
      form.submit();
    });
  });

  // Close the mobile drawer / dropdowns when clicking outside or pressing Escape.
  function closeOpen(except) {
    document.querySelectorAll('.ss-header details[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  document.addEventListener('click', function (e) {
    var inside = e.target.closest('.ss-header details');
    closeOpen(inside);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOpen(null); });
})();
